/* Client-side Segment event names.

Naming convention: {domain}_{object}_{action}
Keep the enum in alphabetical order.
*/
export var TrackingEventNames = /*#__PURE__*/function (TrackingEventNames) {
  TrackingEventNames["COLUMN_ORDER_CHANGED"] = "column_order_changed";
  TrackingEventNames["COSTAR_AUTHENTICATION_COMPLETED"] = "costar_authentication_completed";
  TrackingEventNames["COSTAR_AUTHENTICATION_INITIATED"] = "costar_authentication_initiated";
  TrackingEventNames["COSTAR_IMPORT_INITIATED"] = "costar_import_initiated";
  TrackingEventNames["COSTAR_IMPORT_STEP1_VIEWED"] = "costar_import_step_auth_viewed";
  TrackingEventNames["COSTAR_IMPORT_STEP2_VIEWED"] = "costar_import_step_select_viewed";
  TrackingEventNames["COSTAR_IMPORT_STEP3_VIEWED"] = "costar_import_step_import_viewed";
  TrackingEventNames["COSTAR_IMPORT_STEP4_VIEWED"] = "costar_import_step_preview_viewed";
  TrackingEventNames["COSTAR_IMPORT_VIEW_LISTINGS_CLICKED"] = "costar_import_view_listings_clicked";
  TrackingEventNames["COSTAR_SURVEY_SELECTED"] = "costar_survey_selected";
  TrackingEventNames["COSTAR_SURVEY_UNSELECTED"] = "costar_survey_unselected";
  TrackingEventNames["COSTAR_WIZARD_OPENED"] = "costar_wizard_opened";
  TrackingEventNames["COSTAR_WIZARD_STEP_TRANSITION_CLICKED"] = "costar_wizard_step_transition_clicked";
  TrackingEventNames["CUSTOM_SORT_APPLIED"] = "custom_sort_applied";
  TrackingEventNames["CUSTOM_SORT_SELECTED"] = "custom_sort_selected";
  TrackingEventNames["CURRENT_LOCATION_EDIT_CANCELLED"] = "current_location_edit_cancelled";
  TrackingEventNames["CURRENT_LOCATION_EDIT_CLICKED"] = "current_location_edit_clicked";
  TrackingEventNames["COMPANY_PORTFOLIO_MANAGEMENT_PRODUCT_TOGGLED"] = "company_portfolio_management_product_toggled";
  TrackingEventNames["COMPANY_TRANSACTIONS_PRODUCT_TOGGLED"] = "company_transactions_product_toggled";
  TrackingEventNames["COMPANY_WORKPLACE_ANALYTICS_PRODUCT_TOGGLED"] = "company_workplace_analytics_product_toggled";
  TrackingEventNames["DEALROOM_CLIENT_ACCESS_TOGGLED"] = "dealroom_client_access_toggled";
  TrackingEventNames["DEALROOM_OVERVIEW_DOCUMENT_DOWNLOAD_CLICKED"] = "dealroom_overview_document_download_clicked";
  TrackingEventNames["DOCUMENT_SEARCH_PERFORMED"] = "document_search_performed";
  TrackingEventNames["DOCUMENTS_DOCUMENT_DELETED"] = "documents_document_deleted";
  TrackingEventNames["DOCUMENTS_DOCUMENT_EDITED"] = "documents_document_edited";
  TrackingEventNames["DOCUMENTS_DOCUMENT_OPENED"] = "documents_document_opened";
  TrackingEventNames["DOCUMENTS_NEW_FOLDER_CLICKED"] = "documents_new_folder_clicked";
  TrackingEventNames["DOCUMENTS_UPLOAD_INITIATED"] = "documents_upload_initiated";
  TrackingEventNames["ELEMENT_PRESSED"] = "element pressed";
  TrackingEventNames["FOLDER_SELECTED_DURING_UPLOAD"] = "folder_selected_during_upload";
  TrackingEventNames["LEASE_NAME_SEARCHED"] = "lease_name_searched";
  TrackingEventNames["LEASE_VISIBILITY_TOGGLED"] = "lease_visibility_toggled";
  TrackingEventNames["LISTING_COMMENT_DELETED"] = "listing_comment_deleted";
  TrackingEventNames["LISTING_COMMENT_SUBMITTED"] = "listing_comment_submitted";
  TrackingEventNames["LISTING_CONFIRM_CLICKED"] = "listing_confirm_clicked";
  TrackingEventNames["LISTING_DISLIKE_CLICKED"] = "listing_dislike_clicked";
  TrackingEventNames["LISTING_LIKE_CLICKED"] = "listing_like_clicked";
  TrackingEventNames["LISTING_IMPORT_SUBMITTED"] = "listing_import_submitted";
  TrackingEventNames["LISTINGS_CATEGORY_SAVE_CLICKED"] = "listings_category_save_clicked";
  TrackingEventNames["PROPOSAL_ARCHIVE_CLICKED"] = "proposal_archive_clicked";
  TrackingEventNames["PROPOSAL_DELETE_CLICKED"] = "proposal_delete_clicked";
  TrackingEventNames["PROPOSAL_EDIT_SUBMITTED"] = "proposal_edit_submitted";
  TrackingEventNames["PROPOSAL_UNARCHIVE_CLICKED"] = "proposal_unarchive_clicked";
  TrackingEventNames["PROPOSAL_UPLOAD_SUBMITTED"] = "proposal_upload_submitted";
  TrackingEventNames["PROPOSALS_PROPOSAL_GENERATED"] = "proposals_proposal_generated";
  TrackingEventNames["LISTINGS_FILTER_APPLIED"] = "listings_filter_applied";
  TrackingEventNames["LISTINGS_LISTING_DETAILS_OPENED"] = "listings_listing_details_opened";
  TrackingEventNames["LISTINGS_TOUR_REQUEST_CLICKED"] = "listings_tour_request_clicked";
  TrackingEventNames["RENT_SCHEDULE_FILTER_APPLIED"] = "rent_schedule_filter_applied";
  TrackingEventNames["MOVE_TO_INITIATED"] = "move_to_initiated";
  TrackingEventNames["TOUR_ADD_TO_CALENDAR"] = "tour_add_to_calendar";
  TrackingEventNames["TOUR_STOP_CONFIRMED"] = "tour_stop_confirmed";
  TrackingEventNames["TOUR_STOP_DELETE_CLICKED"] = "tour_stop_delete_clicked";
  TrackingEventNames["TOUR_TOURBOOK_GENERATION_INITIATED"] = "tour_tourbook_generation_initiated";
  TrackingEventNames["TRANSACTION_NOTE_SUBMITTED"] = "transaction_note_submitted";
  TrackingEventNames["TRANSACTION_CLONE_CANCELLED"] = "transaction_clone_cancelled";
  TrackingEventNames["TRANSACTION_CLONE_CLICKED"] = "transaction_clone_clicked";
  TrackingEventNames["TRANSACTION_CLONE_COMPLETED"] = "transaction_clone_completed";
  TrackingEventNames["TRANSACTION_FIELD_EDITED"] = "transaction field edited";
  TrackingEventNames["TRANSACTION_MANAGEMENT_FILTER_APPLIED"] = "transaction_management_filter_applied";
  TrackingEventNames["TRANSACTION_TABLE_EDIT_CLICKED"] = "transaction table edit clicked";
  TrackingEventNames["TRANSACTION_TABLE_SAVE_COMPLETED"] = "transaction table save completed";
  TrackingEventNames["USER_MANAGEMENT_ACCESS_TO_ALL_TOGGLED"] = "user_management_access_to_all_toggled";
  TrackingEventNames["USER_MANAGEMENT_CONTACT_SAVE_CLICKED"] = "user_management_contact_save_clicked";
  TrackingEventNames["USER_MANAGEMENT_PORTFOLIO_MANAGEMENT_PRODUCT_TOGGLED"] = "user_management_portfolio_management_product_toggled";
  TrackingEventNames["USER_MANAGEMENT_TRANSACTIONS_PRODUCT_TOGGLED"] = "user_management_transactions_product_toggled";
  TrackingEventNames["USER_MANAGEMENT_WORKPLACE_ANALYTICS_PRODUCT_TOGGLED"] = "user_management_workplace_analytics_product_toggled";
  TrackingEventNames["WORKPLACE_ANALYTICS_FILTER_APPLIED"] = "workplace_analytics_filter_applied";
  return TrackingEventNames;
}({});

/** Client documents folder UI actions; resolved to TrackingEventNames in DocumentFolderView. */
export var DocumentsEngagementAction = /*#__PURE__*/function (DocumentsEngagementAction) {
  DocumentsEngagementAction["DOCUMENT_OPENED"] = "document_opened";
  DocumentsEngagementAction["NEW_FOLDER"] = "new_folder";
  return DocumentsEngagementAction;
}({});

/** Segment property `section` for DEALROOM_OVERVIEW_DOCUMENT_DOWNLOAD_CLICKED. */
export var DealroomOverviewDocumentDownloadSection = /*#__PURE__*/function (DealroomOverviewDocumentDownloadSection) {
  DealroomOverviewDocumentDownloadSection["DOCUMENTS"] = "documents";
  DealroomOverviewDocumentDownloadSection["PROPOSALS"] = "proposals";
  return DealroomOverviewDocumentDownloadSection;
}({});

/** Segment property `via` for DEALROOM_OVERVIEW_DOCUMENT_DOWNLOAD_CLICKED. */
export var DealroomOverviewDocumentDownloadVia = /*#__PURE__*/function (DealroomOverviewDocumentDownloadVia) {
  DealroomOverviewDocumentDownloadVia["NATIVE_VIEWER"] = "native_viewer";
  DealroomOverviewDocumentDownloadVia["PREVIEW"] = "preview";
  return DealroomOverviewDocumentDownloadVia;
}({});

// Legacy: Used with trackEvent() (e.g. ELEMENT_PRESSED + pageView/context).
// All events show up as ELEMENT_PRESSED in Segment.
// For NEW tracking, prefer adding a specific event name to TrackingEventNames
// Make sure these are in alphabetical order
export var TrackingEventPageView = /*#__PURE__*/function (TrackingEventPageView) {
  TrackingEventPageView["BROKER_DEALROOM_NEW_DEAL"] = "broker dealroom new deal";
  TrackingEventPageView["BROKER_DEALROOM_OVERVIEW"] = "broker dealroom overview";
  TrackingEventPageView["CLIENT_DEALROOM_DOCUMENTS"] = "client dealroom documents";
  TrackingEventPageView["CLIENT_DEALROOM_LISTINGS"] = "client dealroom listings";
  TrackingEventPageView["CLIENT_DEALROOM_OVERVIEW"] = "client dealroom overview";
  TrackingEventPageView["CLIENT_DEALROOM_PROPOSALS"] = "client dealroom proposals";
  TrackingEventPageView["CLIENT_DEALROOM_TOURS"] = "client dealroom tours";
  TrackingEventPageView["CLIENT_ORGANIZATION_DOCUMENTS"] = "client organization documents";
  TrackingEventPageView["PORTFOLIO_MANAGEMENT_ACTIVE_LEASES"] = "portfolio management active leases";
  TrackingEventPageView["PORTFOLIO_MANAGEMENT_DOCUMENTS"] = "portfolio management documents";
  TrackingEventPageView["PORTFOLIO_MANAGEMENT_LEASE_DETAILS"] = "portfolio management lease details";
  TrackingEventPageView["USER_MANAGEMENT"] = "user management";
  return TrackingEventPageView;
}({});

// Legacy: Used with trackEvent() (e.g. ELEMENT_PRESSED + pageView/context).
// All events show up as ELEMENT_PRESSED in Segment.
// For NEW tracking, prefer adding a specific event name to TrackingEventNames
// Make sure these are in alphabetical order
export var TrackingEventContext = /*#__PURE__*/function (TrackingEventContext) {
  TrackingEventContext["ADD_NOTE"] = "add note";
  TrackingEventContext["ADD_OCCUPANCY"] = "add occupancy";
  TrackingEventContext["ADD_OUTREACH"] = "add outreach";
  TrackingEventContext["ADD_REMINDER"] = "add reminder";
  TrackingEventContext["BACK_TO_LISTINGS"] = "back to listings";
  TrackingEventContext["CAROUSEL_ARROWS"] = "carousel arrows";
  TrackingEventContext["CATEGORY_PILL"] = "category pill";
  TrackingEventContext["COPY_LINK"] = "copy link";
  TrackingEventContext["CREATE_NOTE"] = "create note";
  TrackingEventContext["CREATE_OUTREACH"] = "create outreach";
  TrackingEventContext["CREATE_REMINDER"] = "create reminder";
  TrackingEventContext["DEAL_PHASE_UPDATE"] = "deal phase update";
  TrackingEventContext["DEFAULT_BROKER"] = "default broker";
  TrackingEventContext["DOCUMENT_ADDED_COMMENT"] = "document added comment";
  TrackingEventContext["DOWNLOAD_DOCUMENT"] = "download document";
  TrackingEventContext["EDIT_CLIENT_REQUIREMENTS"] = "edit client requirements";
  TrackingEventContext["EDIT_DEAL_SUMMARY"] = "edit deal summary";
  TrackingEventContext["EXECUTE_DEAL"] = "execute deal";
  TrackingEventContext["LEASE_DETAILS"] = "lease details";
  TrackingEventContext["LISTING_CARD"] = "listing card";
  TrackingEventContext["LISTING_DETAILS"] = "listing details";
  TrackingEventContext["MAP_LISTING_DETAILS"] = "map listing details";
  TrackingEventContext["MARK_DEAL_AS_LOST"] = "mark deal as lost";
  TrackingEventContext["MOVE_TO_PURSUITS"] = "move to pursuits";
  TrackingEventContext["NEW_LISTING_THUMBNAIL"] = "new listing thumbnail";
  TrackingEventContext["OPEN_EMAILER"] = "open emailer";
  TrackingEventContext["PAST_TOUR"] = "past tour";
  TrackingEventContext["RESET_DEALROOM"] = "reset dealroom";
  TrackingEventContext["REVERSE_SORT_LISTINGS"] = "reverse sort listings";
  TrackingEventContext["SAVE_CLIENT_REQUIREMENTS"] = "save client requirements";
  TrackingEventContext["SAVE_DEAL"] = "save deal";
  TrackingEventContext["SAVE_DEAL_SUMMARY"] = "save deal summary";
  TrackingEventContext["SHARE_BUTTON"] = "share button";
  TrackingEventContext["SORT_LISTINGS"] = "sort listings";
  TrackingEventContext["TOUR_DETAILS"] = "tour details";
  TrackingEventContext["UPCOMING_TOUR"] = "upcoming tour";
  TrackingEventContext["VIEW_ALL_CRITICAL_DATES"] = "view all critical dates";
  TrackingEventContext["VIEW_LISTINGS"] = "view listings";
  TrackingEventContext["VIEW_PROPOSAL"] = "view proposal";
  return TrackingEventContext;
}({});